import { Outlet, useLocation, matchRoutes } from 'react-router-dom';
import { Tabs, useCurrentCompany } from '@employ-engage/common-components';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface SettingsProps {}

export function Settings(props: SettingsProps) {
  const { t } = useTranslation(['common']);
  const { currentCompany } = useCurrentCompany();
  const location = useLocation();
  const friendlyCompanyId = currentCompany?.friendlyCompanyId;

  const secondaryNavigation = [
    {
      name: t('Organization Setup'),
      to: `/${friendlyCompanyId}/admin/settings`,
      current: !!matchRoutes(
        [
          {
            path: `/${friendlyCompanyId}/admin/settings`,
          },
        ],
        location
      ),
    },
    {
      name: t('Team'),
      to: `/${friendlyCompanyId}/admin/settings/team`,
      current: !!matchRoutes(
        [
          {
            path: `/${friendlyCompanyId}/admin/settings/team`,
          },
        ],
        location
      ),
    },
    {
      name: t('Data feed'),
      to: `/${friendlyCompanyId}/admin/settings/data-feed`,
      current: !!matchRoutes(
        [
          {
            path: `/${friendlyCompanyId}/admin/settings/data-feed`,
          },
        ],
        location
      ),
    },
    {
      name: t('Delete Company'),
      to: `/${friendlyCompanyId}/admin/settings/delete-company`,
      current: !!matchRoutes(
        [
          {
            path: `/${friendlyCompanyId}/admin/settings/delete-company`,
          },
        ],
        location
      ),
    },
  ];

  return (
    <div>
      <main className="p-10 bg-white rounded-2xl shadow">
        <Tabs tabs={secondaryNavigation} />
        <Outlet />
      </main>
    </div>
  );
}

export default Settings;
